<template>
    <div id="forgot-password" class="container-fluid">
        <div class="row align-items-center justify-content-center">
            <div class="col-sm-6">
                <h1>Reset Password</h1>
                
                <form @submit.prevent="requestReset" class="form" v-if="status != 'success'">
                    <p class="mb-4">Enter your email address and a new password below.</p>
                    <b-form-group>
                        <b-form-input v-model.trim.lazy="$v.authData.email.$model" :class="{ 'is-invalid': $v.authData.email.$error }" placeholder="Enter your email address"></b-form-input>
                        <div class="invalid-feedback" v-if="$v.authData.email.$error">Please enter a valid email address</div>
                    </b-form-group>
                    
                    <div class="row">
                        <b-form-group class="col-sm">
                            <b-form-input type="password" v-model.trim="$v.authData.password.$model" :class="{ 'is-invalid': $v.authData.password.$error }" placeholder="Choose a password"></b-form-input> 
                            <div class="invalid-feedback" v-if="$v.authData.password.$error">Please enter a stronger password <a v-b-tooltip.hover title="Good passwords are hard to guess. Use uncommon words or inside jokes, non-standard uPPercasing, creative spelllling, and non-obvious numbers and symbols."><fa-icon :icon="['fal', 'info-circle']" /></a></div>
                        </b-form-group>
                        <b-form-group class="col-sm">
                            <b-form-input type="password" v-model.trim="$v.authData.password_confirmation.$model" :class="{ 'is-invalid': $v.authData.password_confirmation.$error }" placeholder="Re-enter your password"></b-form-input> 
                            <div class="invalid-feedback" v-if="$v.authData.password_confirmation.$error">Passwords must match</div>
                        </b-form-group>
                    </div>
                    
                    <div class="alert alert-danger" v-if="status == 'error'">{{ statusMessage }}</div>
                    
                    <SubmitButton title="Reset Password" :is-disabled="$v.$invalid || !$v.$anyDirty" :is-saving="isSaving" />
                </form>
                
                <div class="alert alert-success" v-else>{{ statusMessage }} <better-link to="/login">Log In</better-link></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import SubmitButton from '@/components/form-controls/SubmitButton'

import { validationMixin } from 'vuelidate'
import required from 'vuelidate/lib/validators/required'
import email from 'vuelidate/lib/validators/email'
import sameAs from 'vuelidate/lib/validators/sameAs'
import goodPassword from '@/vuelidate/goodPassword'

export default {
    name: 'ResetPassword',
    mixins: [
        validationMixin
    ],
    components: {
        SubmitButton,
    },
    head: {
        title() {
            return {
                inner: 'Reset Password',
            }
        },
    },
    validations: {
        authData: {
            email: {
                required,
                email,
            },
            password: {
                required,
                goodPassword,
            },
            password_confirmation: {
                sameAsPassword: sameAs('password'),
            },
        },
    },
    data() {
        return {
            authData: {
                email: this.$route.query.email,
                token: this.$route.query.token,
                password: '',
                password_confirmation: '',
            },
            isSaving: false,
            status: '',
            statusMessage: '',
        }
    },
    methods: {
        requestReset() {
            this.status = ''
            this.isSaving = true
            axios({
                url: process.env.VUE_APP_API_BASE_URL + '/password/reset',
                method: 'POST',
                data: {
                    ...this.authData,
                },
            }).then(response => {
                this.isSaving = false
                this.status = 'success'
                this.statusMessage = response.data.message
            }).catch(error => {
                this.isSaving = false
                this.status = 'error'
                this.statusMessage = error.response.data.message
            })
        },
    },
    activated() {
        this.$emit('updateHead')
    },
};
</script>